import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { Icon } from "./icon";

const Background = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #1f1f1f;
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
`;

const HeartIcon = styled(Icon)`
    width: 1.25rem;
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
`;

const SaveButton = ({ className, saved }) => {
    return (
        <Background className={className}>
            <HeartIcon type={saved ? "heart-filled" : "heart-outline"} />
        </Background>
    );
};

SaveButton.propTypes = {
    className: PropTypes.string,
    saved: PropTypes.bool.isRequired
};

export { SaveButton };

// TODO:
// replace Icon with styled svg
